export type ILoadChildFormViaAjax = (button: IjQueryElmOrHtmlElm) => void;

export function _loadChildFormViaAjax(button: IjQueryElmOrHtmlElm): void {
  const $body = $('body');
  const $button = $(button) as IjQueryElm;
  const $formGroup = $button.closest('.form-group');
  const $addButton = $formGroup.find('.add-button.ajax-action');
  const userOptions = window.DexeroCoreApp.getUserOptions();
  const { langObj = {} } = userOptions;
  const $form = $button.closest('form');
  const action = $form.attr('action') as string;
  const $uuidInput = $form.find('input[name="uuid"]');
  // Subform action realted inputs
  const $subActionInput = $form.find('input[name="subAction"]');
  const $subFormIdInput = $form.find('input[name="subFormId"]');
  const $subDataBundleUUIDInput = $form.find('input[name="subDataBundleUUID"]');
  const $subPageIdInput = $form.find('input[name="subPageId"]');
  const $singlePageInput = $form.find('input[name="singlePage"]');

  const dataEntryExists = !!$uuidInput.val();
  const $mainFieldSubFormHolder = $button.closest('.fieldSubForm');
  const json = JSON.parse(decodeURIComponent($button.data('json')));
  const {
    display,
    formLoadUlr,
    formLoadHolder,
    getNewEntryHtmlUrl,
    subAction,
    subFormId,
    subFormFieldId,
    subDataBundleUUID,
    subPageId,
    singlePage,
  } = json;
  const $formLoadHolder = $(formLoadHolder);
  const $subFormLoadHolder =
    display === 'table'
      ? $formLoadHolder.find('> td').first()
      : $formLoadHolder.find('> div').first();
  const postUrl = `${action}${window.DexeroCoreApp.getUrlSeperator(
    action
  )}ajax=true&partialSave=true`;

  let $subForm: JQuery<HTMLFormElement>;
  let subFormAction: string;
  let $subFormSubmitButton: IjQueryElmOrHtmlElm;
  let _getNewEntryHtmlUrl = getNewEntryHtmlUrl;

  // Animate add button to let user know something is happening
  window.DexeroCoreApp.animateButton($addButton);
  // Update subform add/edit/remove specific inputs
  function _updateSubformActionInputs(revert = false) {
    $subActionInput.val(revert ? '' : subAction);
    $subFormIdInput.val(revert ? '' : subFormId);
    $subDataBundleUUIDInput.val(revert ? '' : subDataBundleUUID);
    $subPageIdInput.val(revert ? '' : subPageId);
    $singlePageInput.val(revert ? '' : singlePage);
  }

  // Get main form UUID
  function _getMainFormUuid() {
    const mainFormDfd = new ($ as any).Deferred();
    const currentUrl = window.location.href;
    const hasUuidParam = window.DexeroCoreApp.getUuidValueInUrl(currentUrl) !== null;
    const uuid = '';
    let obj;
    // if the main form has not been submited yet, we need to submit it to get a dataBundleUuid, which will be our subForm pUuid
    if (!dataEntryExists) {
      // Block form
      window.DexeroCoreApp.blockUI($form);
      // Update subFormAction inputs to ensure parent form is created in create mode
      _updateSubformActionInputs();
      $.post(postUrl, $form.serialize())
        .done((responseData) => {
          if (responseData.success === 'true') {
            obj = { mainFormUuuid: responseData.newDataBundleUUID };
            $uuidInput.val(responseData.newDataBundleUUID);
            _getNewEntryHtmlUrl = getNewEntryHtmlUrl.replace(
              '**DATA_ENTRY_UUID**',
              responseData.newDataBundleUUID
            );
            // If this is first page load, there will be no uuid in the url param, so we need to add it in case the user reloads the page after adding subcards
            if (!hasUuidParam) {
              window.history.pushState(
                {},
                '',
                `${currentUrl}${window.DexeroCoreApp.getUrlSeperator(
                  currentUrl
                )}uuid=${$uuidInput.val()}`
              );
            }
            mainFormDfd.resolve(obj);
          } else {
            obj = { mainFormUuuid: false };
            mainFormDfd.reject(obj);
          }
        })
        .always(() => {
          window.DexeroCoreApp.blockUI(undefined, $form, true);
          // Revert subFormActionInputs to default values
          _updateSubformActionInputs(true);
        });
    } else {
      obj = { mainFormUuuid: $uuidInput.val() };
      _getNewEntryHtmlUrl = getNewEntryHtmlUrl.replace('**DATA_ENTRY_UUID**', $uuidInput.val());
      mainFormDfd.resolve(obj);
    }
    return mainFormDfd.promise(uuid);
  }

  // Get new child elemnt HTML to insert
  function _getNewChildHTML(uuid: string) {
    $.get(`${_getNewEntryHtmlUrl}${uuid}`).done((responseData) => {
      // Reload subform
      $mainFieldSubFormHolder.empty().append($(responseData));
      // Trigger focus out on required elements if it exists to revalidate subform required attribute
      const $subFormRequiredInput = $mainFieldSubFormHolder.find(
        '.special-validation-input.subFormRequired'
      );
      if ($subFormRequiredInput.length) {
        $subFormRequiredInput.valid();
      }
      // Publish subform id change
      window.DexeroCoreApp.publish('/subform/updated', {
        form: $form,
        mainFieldSubFormHolder: $mainFieldSubFormHolder,
        subFormFieldId,
        subFormId,
      });
      // Show success message
      window.DexeroCoreApp.userToastMsg('success', langObj.successCompletionMsgText, '');
    });
  }

  // Handle subform submit button click
  function _onSubFormSubmit(event: JQuery.ClickEvent) {
    event.preventDefault();
    if ($subForm.valid()) {
      window.DexeroCoreApp.blockUI($subForm);
      window.DexeroCoreApp.animateButton($subFormSubmitButton);

      // Form Object
      const formData = new FormData($subForm[0]);
      $.ajax({
        cache: false,
        contentType: false,
        data: formData,
        processData: false,
        timeout: 90000,
        type: 'POST',
        url: `${subFormAction}${window.DexeroCoreApp.getUrlSeperator(subFormAction)}ajax=true`,
        error(jqXHR, textStatus) {
          if (textStatus === 'timeout') {
            const errorTitle = 'Erreur';
            const errorMessage = "Impossible d'afficher cette page.";
            window.DexeroCoreApp.userToastMsg('error', errorTitle, errorMessage);
            window.DexeroCoreApp.animateButton($subFormSubmitButton);
          }
        },
      }).done((responseData) => {
        if (responseData.success === 'true') {
          _getNewChildHTML(responseData.newDataBundleUUID);
          $body.find('.modal-backdrop').remove();
          $formGroup.removeClass('z-index-1041');
        } else {
          window.DexeroCoreApp.displayJsonErrors(responseData.formError, $subForm.data('suffix'));
          window.DexeroCoreApp.unblockUI($subForm);
          window.DexeroCoreApp.animateButton($subFormSubmitButton);
        }
      });
    }
  }

  // Setup subfrom inside holder
  function _setupSubForm(responseData: IDCA.IPostResponse) {
    // Focus in on subform
    $formGroup.addClass('z-index-1041');
    $body.append('<div class="modal-backdrop fade in"></div>');
    // Place form inside holder
    // If it's a table we have to place the form inside a TD
    $subFormLoadHolder.empty().append(`<div class="well alt">${responseData}</div>`);

    $subForm = $formLoadHolder.find('form');
    subFormAction = $subForm.attr('action') as string;
    $subFormSubmitButton = $subForm.find('button[type="submit"]') as IjQueryElm;
    // Hook up validation on loaded form
    window.DexeroCoreApp.handleValidation();
    // Run necessary form bindings
    window.DexeroCoreApp._datepickers();
    window.DexeroCoreApp._formBindings();
    window.DexeroCoreApp._initFieldsFormlinkWithChilds();
    window.DexeroCoreApp._initPasswordFields();
    window.DexeroCoreApp._initRadioUnCheck();
    window.DexeroCoreApp._initReCaptchaFields();
    window.DexeroCoreApp._initSignatureFields();
    window.DexeroCoreApp._initTooltips();
    window.DexeroCoreApp._initWYSIWYG();
    window.DexeroCoreApp._maskDecimalFields();
    window.DexeroCoreApp._maskMoneyFields();
    window.DexeroCoreApp._maskNumberFields();
    window.DexeroCoreApp._maskPercentFields();
    window.DexeroCoreApp._maskPhoneNumbers();
    window.DexeroCoreApp._maskPosteNumbers();
    window.DexeroCoreApp._maskZipCodes();
    window.DexeroCoreApp._textAreaCharCounter();

    // Prevent submit button on child from from reloading page
    $subFormSubmitButton.on('click', (event) => {
      _onSubFormSubmit(event);
    });
    // Show form
    $formLoadHolder.removeClass('hide');

    const $fistVisibleSubformField = $subForm.find(':input:visible').first();
    if ($fistVisibleSubformField.length) {
      $fistVisibleSubformField.focus();
      ($fistVisibleSubformField as any).scrollTo();
    } else {
      ($subForm as any).scrollTo();
    }

    // Publish subform open after it's been shown
    DCA.publish('/subform/opened', {
      form: $form,
      mainFieldSubFormHolder: $mainFieldSubFormHolder,
      subFormFieldId,
      subFormId,
    });
  }

  // Get the form
  _getMainFormUuid().done((mainFormUuuid: { mainFormUuuid: string }) => {
    if (mainFormUuuid.mainFormUuuid) {
      $.get(
        `${formLoadUlr}${window.DexeroCoreApp.getUrlSeperator(formLoadUlr)}ajax=true&puuid=${
          mainFormUuuid.mainFormUuuid
        }`
      ).done((responseData) => {
        _setupSubForm(responseData);
      });
    }
  });
}
